exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-radio-group{font-family:\"Monospaced Number\",Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.5;color:#5d5d5d;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;list-style:none}.mm-radio-group .mm-radio{margin-right:20px}", ""]);

// exports
